import { render, staticRenderFns } from "./AcsD_Details.vue?vue&type=template&id=1e24b8d2"
import script from "./AcsD_Details.vue?vue&type=script&lang=js"
export * from "./AcsD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports